import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'
import { openRemoteFileInNewTab } from 'sharedKernel/file/remoteFile'
import { LabelInputFile } from 'sharedKernel/styledComponents/fileComponents/styles'
import { checkJSON } from '..'
import { FileDiv } from '.././styles'
import { FormAnswerProps } from '../contracts'

export const FormAnswerUpload = ({ answer }: FormAnswerProps): JSX.Element => {
  if (answer.archive === null && answer.answerValue !== '') {
    return checkJSON(answer)
  }

  const { id, path, name, mimetype } = answer.archive

  const handleOpenFile = (event: React.MouseEvent<HTMLAnchorElement>): void => {
    if (id == null) return

    event.preventDefault()
    void openRemoteFileInNewTab({
      url: `/v1/hub/company/solution/file/${id}/content`,
      fallbackPath: String(path),
      name,
      mimetype
    })
  }

  return (
    <FileDiv>
      {path != null
        ? (
          <a href={String(path)} target="_blank" onClick={handleOpenFile}>
            <LabelInputFile isClickable>
              <FontAwesomeIcon className="pr-2" icon={['fas', 'panorama']} />
              {name}
            </LabelInputFile>
          </a>
          )
        : (
      <LabelInputFile isClickable>
        <FontAwesomeIcon className="pr-2" icon={['fas', 'panorama']} />
        {name}
      </LabelInputFile>
          )}
    </FileDiv>
  )
}
